function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import layerEvents from "../../lib/layerEvents";
import mixin from "./layerMixin";
export default {
  name: "RasterLayer",
  mixins: [mixin],
  created: function created() {
    this.$_deferredMount();
  },
  methods: {
    $_deferredMount: function $_deferredMount() {
      var source = _objectSpread({
        type: "raster"
      }, this.source);

      this.map.on("dataloading", this.$_watchSourceLoading);

      try {
        this.map.addSource(this.sourceId, source);
      } catch (err) {
        if (this.replaceSource) {
          this.map.removeSource(this.sourceId);
          this.map.addSource(this.sourceId, source);
        }
      }

      this.$_addLayer();
      this.$_bindLayerEvents(layerEvents);
      this.map.off("dataloading", this.$_watchSourceLoading);
      this.initial = false;
    },
    $_addLayer: function $_addLayer() {
      var existed = this.map.getLayer(this.layerId);

      if (existed) {
        if (this.replace) {
          this.map.removeLayer(this.layerId);
        } else {
          this.$_emitEvent("layer-exists", {
            layerId: this.layerId
          });
          return existed;
        }
      }

      var layer = _objectSpread({
        id: this.layerId,
        type: "raster",
        source: this.sourceId
      }, this.layer);

      this.map.addLayer(layer, this.before);
      this.$_emitEvent("added", {
        layerId: this.layerId
      });
    }
  }
};